import { Button } from '@we-agile-you/react-base';
import cx from 'classnames';
import React, { useEffect, useState } from 'react';
import { throttle } from 'lodash';
import { Link } from '../../atoms/Link/Link';
import { LogoWay } from '../../atoms/LogoWay/LogoWay';

import { AuthButton } from '../../../containers/AuthButton/AuthButton';
import styles from './Header.module.scss';
import { LogoIcon } from '../../atoms/LogoIcon/LogoIcon';
import { BurgerButtonDropdown } from '../../molecules/BurgerButtonDropdown/BurgerButtonDropdown';

interface HeaderProps {
  title?: React.ReactNode;
  isHome?: boolean;
  isMinimal?: boolean;
  isShowShadowOnScrolled?: boolean;
}

export const Header = ({
  title,
  isHome,
  isMinimal,
  isShowShadowOnScrolled,
}: HeaderProps) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isBurgerMenu, setIsBurgerMenu] = useState(false);

  useEffect(() => {
    const handleWindowScroll = throttle(() => {
      setIsScrolled(
        document.body.scrollTop > 20 || document.documentElement.scrollTop > 20,
      );
    }, 50);

    window.addEventListener('scroll', handleWindowScroll);

    return () => {
      window.removeEventListener('scroll', handleWindowScroll);
    };
  }, []);

  useEffect(() => {
    const handleWindowResize = throttle(() => {
      setIsBurgerMenu(document.body.clientWidth < 920);
    }, 50);

    handleWindowResize();

    window.addEventListener('resize', handleWindowResize);

    return () => {
      window.removeEventListener('resize', handleWindowResize);
    };
  }, []);

  const className = cx(styles['header'], {
    [styles['header--home']]: isHome,
    [styles['header--minimal']]: isMinimal,
    [styles['header--shadow-on-scroll']]: isShowShadowOnScrolled,
    [styles['header--scrolled']]: isScrolled,
  });

  const handleHeaderClick = () => {
    if (isShowShadowOnScrolled) {
      window.scroll({ top: 0 });
    }
  };

  return (
    <>
      <header className={className}>
        <div className={styles['left']}>
          {isHome ? (
            <Link
              to="/"
              className={styles['logo-way-link']}
              title="Retrospective Online"
              onClick={() => window.scroll({ top: 0 })}
            >
              <LogoWay />
              <span className={styles['beta-label']}>Beta</span>
            </Link>
          ) : (
            <>
              <Link to="/" className={styles['logo-link']}>
                <LogoIcon color="primary" className={styles['logo-icon']} />
                <span className={styles['beta-label']}>Beta</span>
              </Link>
              <h1
                className={cx(
                  styles.title,
                  'notranslate',
                  isShowShadowOnScrolled && styles['title--anchor'],
                )}
                translate="no"
                onClick={handleHeaderClick}
              >
                {title || 'Retrospective Online'}{' '}
              </h1>
            </>
          )}
        </div>
        <div className={styles['right']}>
          {isHome && (
            <Link to="/new-retrospective" className={styles['cta']}>
              <Button>Start new retrospective</Button>
            </Link>
          )}
          {!isMinimal && (
            <>
              <div className={styles['auth-button']}>
                <AuthButton buttonColor="primary" />
              </div>
              {isBurgerMenu && (
                <div className={styles['burger-button']}>
                  <BurgerButtonDropdown />
                </div>
              )}
            </>
          )}
        </div>
      </header>
    </>
  );
};

export default Header;
